export enum PermissionType {
  // ----------- USER -----------
  User_GetList = 'User_GetList',
  User_GetOne = 'User_GetOne',
  User_CreateOne = 'User_CreateOne',
  User_UpdateOne = 'User_UpdateOne',
  User_ActivateOne = 'User_ActivateOne',
  User_DeactivateOne = 'User_DeactivateOne',
  User_RevokeOtpVerification = 'User_RevokeOtpVerification',
  // ----------- AUTH -----------
  Auth_ResetPassword = 'Auth_ResetPassword',
  Auth_SendAccountActivationEmail = 'Auth_SendAccountActivationEmail',
  Auth_SendInvitationToAccountEmail = 'Auth_SendInvitationToAccountEmail',
  // ----------- CLIENT & LEGAL CLIENT -----------
  Client_LegalClient_GetList = 'Client_LegalClient_GetList',
  Client_LegalClient_GetOne = 'Client_LegalClient_GetOne',
  Client_LegalClient_CreateOne = 'Client_LegalClient_CreateOne',
  Client_LegalClient_UpdateOne = 'Client_LegalClient_UpdateOne',
  Client_LegalClient_DeleteIncompleteOne = 'Client_LegalClient_DeleteIncompleteOne',
  Client_LegalClient_RevokeOtpVerification = 'Client_LegalClient_RevokeOtpVerification',
  Client_LegalClient_EnableBrightSync = 'Client_LegalClient_EnableBrightSync',
  Client_LegalClient_ExportQuestionnaire = 'Client_LegalClient_ExportQuestionnaire',
  History_Client_LegalClient_GetOne = 'History_Client_LegalClient_GetOne',
  Client_LegalClient_SaveOnboardingStatus = 'Client_LegalClient_SaveOnboardingStatus',
  Client_LegalClient_SaveAccountStatus = 'Client_LegalClient_SaveAccountStatus',
  LegalClientBeneficiary_DeleteOne = 'LegalClientBeneficiary_DeleteOne',
  LegalClientBody_DeleteOne = 'LegalClientBody_DeleteOne',
  LegalClientBranch_DeleteOne = 'LegalClientBranch_DeleteOne',
  LegalClientHead_DeleteOne = 'LegalClientHead_DeleteOne',
  LegalClientChildEntity_CreateOne = 'LegalClientChildEntity_CreateOne',
  LegalClientChildEntity_ArchiveOne = 'LegalClientChildEntity_ArchiveOne',
  // ----------- ACCOUNT -----------
  Account_CreateOne_EditOne_ArchiveOne = 'Account_CreateOne_EditOne_ArchiveOne',
  Account_DeleteOne = 'Account_DeleteOne',
  // ----------- SYSTEM SETTING -----------
  SystemSetting_GetOne = 'SystemSetting_GetOne',
  SystemSetting_UpdateOne = 'SystemSetting_UpdateOne',
  // ----------- DOCUMENT -----------
  Document_DeleteAnyOne = 'Document_DeleteAnyOne',
  Document_DeleteAdminOne = 'Document_DeleteAdminOne',
  // ----------- ORDER -----------
  Order_GetList = 'Order_GetList',
  Order_GetOne = 'Order_GetOne',
  Order_UpdateSignedOne = 'Order_UpdateSignedOne',
  Order_UpdateUnsignedOne = 'Order_UpdateUnsignedOne',
  Order_UpdateStatus = 'Order_UpdateStatus',
  Order_CreateOne = 'Order_CreateOne',
  Order_DeleteOne = 'Order_DeleteOne',
  Order_Export = 'Order_Export',
  // ----------- DIRECTORY -----------
  Directory_GetList = 'Directory_GetList',
  Directory_UpdateOne = 'Directory_UpdateOne',
  Directory_ArchiveOne = 'Directory_ArchiveOne',
  Directory_DeleteOne = 'Directory_DeleteOne',
  // ----------- FM1 FORM -----------
  Fm1Form_Access = 'Fm1Form_Access',

  // ----------- OPERATION -----------
  Operation_CreateOneViaList = 'Operation_CreateOneViaList',
  Operation_CreateOneViaOrder = 'Operation_CreateOneViaOrder',
  Operation_GetList = 'Operation_GetList',
  Operation_GetOne = 'Operation_GetOne',
  Operation_UpdateOne = 'Operation_UpdateOne',
  Operation_DeleteOne = 'Operation_DeleteOne',
  Operation_SaveStatus = 'Operation_SaveStatus',
}
